const SvgMap = {
  common: {
    acorn: 'Acornsingle',
    practiceBackground: 'PracticeStaticBackground',
    instructionBackground: 'PracticeStaticBackground',
    standardBackground: 'StandardStaticBackground',
    bottomLeaves: 'StandardAnimBottomLeaves',
    frontLeaves: 'StandardAnimTopLeaves',
    squirrel: 'StandardSquirrel',
    doneButton: 'Button',
    carving: 'Carving',
    plank: 'Plank',
    rock: 'Rock',
  },
  level1item1: [
    'Set01StandardStaticSmile',
    'Set01StandardStaticGiggle',
    'Set01StandardStaticLaugh',
  ],
  level1item2: [
    'Set02StandardStaticHop',
    'Set02StandardStaticJump',
    'Set02StandardStaticLeap',
  ],
  level1item3: [
    'Set03StandardStaticBite',
    'Set03StandardStaticSnack',
    'Set03StandardStaticMeal',
    'Set03StandardStaticFeast',
  ],
  level1item4: [
    'Set04StandardStaticRaindrop',
    'Set04StandardStaticDrizzle',
    'Set04StandardStaticShower',
    'Set04StandardStaticStorm',
  ],
  level1item5: [
    'Set05StandardStaticMicroscopic',
    'Set05StandardStaticTiny',
    'Set05StandardStaticHuge',
    'Set05StandardStaticGigantic',
    'Set05StandardStaticColossal',
  ],
  level1item6: [
    'Set7Temperature1',
    'Set7Temperature2',
    'Set7Temperature3',
    'Set7Temperature4',
  ],
  level2item1: [
    'Set06StandardStaticPoor',
    'Set06StandardStaticFair',
    'Set06StandardStaticGood',
    'Set06StandardStaticExcellent',
    'Set06StandardStaticPerfect',
  ],
  level2item2: [
    'Set08R11Joyful',
    'Set08R12Content',
    'Set08R13Bothered',
    'Set08R14Angry',
    'Set08R15Furious',
  ],
  level2item3: [
    'Set09StandardStaticDisgusting',
    'Set09StandardStaticUnappetizing',
    'Set09StandardStaticTasteless',
    'Set09StandardStaticDelicious',
    'Set09StandardStaticScrumptious',
  ],
  level2item4: [
    'Set10StandardStaticWalk',
    'Set10StandardStaticSkip',
    'Set10StandardStaticJog',
    'Set10StandardStaticRun',
    'Set10StandardStaticSprint',
  ],
  level2item5: [
    'Set11StandardStaticExhausted',
    'Set11StandardStaticWeak',
    'Set11StandardStaticAble',
    'Set11StandardStaticStrong',
    'Set11StandardStaticPowerful',
  ],
  level2item6: [
    'Set12R11Pout',
    'Set12R12Whimper',
    'Set12R13Cry',
    'Set12R14Sob',
    'Set12R15Bawl',
  ],
  level3item1: [
    'Set13StandardStaticDrop',
    'Set13StandardStaticPuddle',
    'Set13StandardStaticPool',
    'Set13StandardStaticLake',
    'Set13StandardStaticOcean',
  ],
  level3item2: [
    'Set14R11Scrape',
    'Set14R12Damage',
    'Set14R13Break',
    'Set14R14Shatter',
    'Set14R15Demolish',
  ],
  level3item3: [
    'Set151Shuffle',
    'Set152Stroll',
    'Set153March',
    'Set154Jog',
    'Set155Sprint',
  ],
  level3item4: [
    'Set16R11Ignore',
    'Set16R12Glance',
    'Set16R13View',
    'Set16R14Stare',
    'Set16R15Scrutinize',
  ],
  level3item5: [
    'Set17R31Drop',
    'Set17R32Lob',
    'Set17R33Toss',
    'Set17R34Fling',
    'Set17R35Hurl',
  ],
  level3item6: [
    'Set18R11Individual',
    'Set18R12Pair',
    'Set18R13Group',
    'Set18R14Team',
    'Set18R15Crowd',
  ],
  level4item1: [
    'Set19StandardStaticHate',
    'Set19StandardStaticDislike',
    'Set19StandardStaticFavor',
    'Set19StandardStaticAdmire',
    'Set19StandardStaticAdore',
  ],
  level4item2: [
    'Set201Hideous',
    'Set202Unattractive',
    'Set203Plain',
    'Set204Pretty',
    'Set205Gorgeous',
  ],
  level4item3: [
    'Set211Alert',
    'Set212Awake',
    'Set213Drowsy',
    'Set214Exhuasted',
    'Set215Asleep',
  ],
  level4item4: [
    'Set221Easy',
    'Set222Managable',
    'Set223Tricky',
    'Set224Hard',
    'Set225Impossible',
  ],
  level4item5: [
    'Set23StandardStaticDifference',
    'Set23StandardStaticDisagreement',
    'Set23StandardStaticSquabble',
    'Set23StandardStaticFight',
    'Set23StandardStaticBrawl',
  ],
  level4item6: [
    'Set24StandardStaticWhisper',
    'Set24StandardStaticMumble',
    'Set24StandardStaticTalk',
    'Set24StandardStaticShout',
    'Set24StandardStaticShriek',
  ],

  level5item1: [
    'Set25StandardStaticUnhappy',
    'Set25StandardStaticIndifferent',
    'Set25StandardStaticGlad',
    'Set25StandardStaticDelighted',
    'Set25StandardStaticOverjoyed',
  ],
  level5item2: [
    'Set26StandardStaticSilent',
    'Set26StandardStaticQuiet',
    'Set26StandardStaticLoud',
    'Set26StandardStaticRoaring',
    'Set26StandardStaticDeafening',
  ],
  level5item3: [
    'Set27R11Uninterested',
    'Set27R12Curious',
    'Set27R13Enthusiastic',
    'Set27R14Fascinated',
    'Set27R15Obsessed',
  ],
  level5item4: [
    'Set28R11Parched',
    'Set28R12Damp',
    'Set28R13Moist',
    'Set28R14Soggy',
    'Set28R15Drenched',
  ],
  level5item5: [
    'Set29StandardStaticSpotless',
    'Set29StandardStaticClean',
    'Set29StandardStaticDirty',
    'Set29StandardStaticFilthy',
    'Set29StandardStaticDisgusting',
  ],
  level5item6: [
    'Set301Couple',
    'Set302Handful',
    'Set303Pile',
    'Set304Mound',
    'Set305Mountain',
  ],
};

export default SvgMap;
